import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as homeActions from '../actions/homeActions';
import * as pricingActions from '../actions/pricingActions';
import PreBookingCard from '../components/PreBookingCard';
import Hero from '../components/Hero';
import { getEndDateFromStartDateAndDurationUnit,getTimeDifference,getDatetimeFromTime,getDateString } from '../utils/dates';
import { getDurationUnits } from '../utils/durationUnits';
import { history } from '../store/configureStore';
import Banner from '../components/Banner';

import SpecialDealDetails from '../components/SpecialDealDetails';
import LocationDetails from '../components/LocationDetails';
import {removeState} from '../store/localStorage';
import {userActions} from '../actions/userActions';
import getPortalLocData from '../config/loc';
import GenericContent from './GenericContent';

// import { Map, GoogleApiWrapper,Marker,InfoWindow  } from 'google-maps-react';





export class HomePage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    removeState();
    this.props.userActions.reset();
    this.props.userActions.logout();
    this.props.homeActions.getOfferings();
    console.log('thing');
  }

 
  // eslint-disable-next-line react/sort-comp
  handlerSubmit=()=>{
    let { untilDate,startDate,selectedLocation,selectedOffering} = this.props.locationDetail;

    if(!untilDate){
      this.props.homeActions.updateBookingToDate(getEndDateFromStartDateAndDurationUnit(startDate,1,getDurationUnits(3)).toISOString());
    }
    if(selectedOffering.type!=0){
      this.props.homeActions.updateBookingToDate(getEndDateFromStartDateAndDurationUnit(startDate,1,getDurationUnits(3)).toISOString());
    }
    let findService=selectedLocation.offerings.filter(s=>s.type==0)[0];
    this.props.homeActions.setSelectedOffer(findService);
    this.props.pricingActions.SelectPricingModel(this.props.pricing.defaultPricingModel);

    this.notRouter("/bookingdetail");
  }

  notRouter ( link ) {
    window.scrollTo(0, 0);
    history.push(link);
  }


  getDescriptionWrap(description) {
    return { __html: description};
  }










render() {
    let { selectedLocation, isFetching, startDate, untilDate, untilDateChanged } = this.props.locationDetail;
    let { isLoading } = this.props.pricing;

    return (
      <div className="">  
        { getPortalLocData().pages.home.heroHead && 
          <div className="position-relative banner-with-banner">
            <Hero 
              title={getPortalLocData().copy.heroHead}
              desc={getPortalLocData().copy.heroP}
              img={"/images/" + getPortalLocData().name + "/bg.jpg"}/>
            <Banner />
          </div>
        }
        <div className="limit-content main-container">

          <div className="account-details">
            <div className="row">
            {
              (selectedLocation && selectedLocation.location && selectedLocation.offerings) ?
                selectedLocation.offerings
                  .filter((deal) => deal.type === 0)
                  .map((deal) => (
                    
                    <div className={"col-sm-12 " + (getPortalLocData().pages.home.heroHead ? "mt-n5" : "mt-5")}  key={deal.id}>
                      <div className="">
                        <div className="p-0 mb-5">
                          <PreBookingCard
                            isLoading={isLoading}
                            handleFromTimeChange={this.handlerFromTimeChange}
                            handleToTimeChange={this.handlerToTimeChange}
                            onSubmit={this.handlerSubmit}
                            locationId={selectedLocation.location.id}
                            minimumDuration={deal.pricing.minimumDuration}
                            maximumDuration={deal.pricing.maximumDuration}
                            durationUnits={deal.pricing.durationUnits ? deal.pricing.durationUnits : 3}
                            startTime={startDate}
                            untilTime={untilDateChanged ? untilDate : getEndDateFromStartDateAndDurationUnit(startDate, 1, getDurationUnits(deal.pricing.durationUnits ? deal.pricing.durationUnits : 3)).toISOString()}
                            offeringId={deal.id}
                            disabled={deal.type !== 0}
                          />
                        </div>
                      </div>
                    </div>
                  ))
                  : []
            }
              

              { !selectedLocation.offerings &&
                  <div className={"theSpinner " + (!selectedLocation.offerings ? "theSpinner__loading" : "")}>
                    <svg className='easyTripSpinner' width='112px' height='112px' viewBox='0 0 19 22' version='1.1' xmlns='http://www.w3.org/2000/svg' ><g id='Group' transform='translate(0.709717, 0.077917)'><g className='easyTripSpinner_1'><path d='M9.07996962,0.82933214 C14.0063664,0.82933214 18,4.82295217 18,9.74933214 C18,14.6757121 14.0063664,18.6693321 9.07996962,18.6693321 C4.15357287,18.6693321 0.159939236,14.6757121 0.159939236,9.74933214 C0.159939236,4.82295217 4.15357287,0.82933214 9.07996962,0.82933214 Z M8.17312792,1.6268611 C4.09628527,1.6268611 0.791351318,4.94626561 0.791351318,9.04095859 C0.791351318,13.1356516 4.09628527,16.4550561 8.17312792,16.4550561 C12.2499706,16.4550561 15.5549045,13.1356516 15.5549045,9.04095859 C15.5549045,4.94626561 12.2499706,1.6268611 8.17312792,1.6268611 Z' id='Combined-Shape' fill='#129ADA'></path></g><g className='easyTripSpinner_2'><path d='M9.03917101,2.15993924 C13.965551,2.15993924 17.959171,6.15357287 17.959171,11.0799696 C17.959171,16.0063664 13.965551,20 9.03917101,20 C4.11279104,20 0.119171007,16.0063664 0.119171007,11.0799696 C0.119171007,6.15357287 4.11279104,2.15993924 9.03917101,2.15993924 Z M9.96842921,4.65221716 C6.15514241,4.65221716 3.06386268,7.93254751 3.06386268,11.9790401 C3.06386268,16.0255326 6.15514241,19.305863 9.96842921,19.305863 C13.781716,19.305863 16.8729957,16.0255326 16.8729957,11.9790401 C16.8729957,7.93254751 13.781716,4.65221716 9.96842921,4.65221716 Z' id='Combined-Shape' fill='#129ADA'></path></g><g className='easyTripSpinner_3'><path d='M9.03917101,8.50823296 C12.5174982,8.50823296 15.3372396,11.328839 15.3372396,14.808233 C15.3372396,18.2876269 12.5174982,21.108233 9.03917101,21.108233 C5.56084378,21.108233 2.74110243,18.2876269 2.74110243,14.808233 C2.74110243,11.328839 5.56084378,8.50823296 9.03917101,8.50823296 Z M8.42274475,9.39283853 C5.55088259,9.39283853 3.22277832,11.6546718 3.22277832,14.4447846 C3.22277832,17.2348974 5.55088259,19.4967307 8.42274475,19.4967307 C11.2946069,19.4967307 13.6227112,17.2348974 13.6227112,14.4447846 C13.6227112,11.6546718 11.2946069,9.39283853 8.42274475,9.39283853 Z' id='Combined-Shape' fill='#129ADA'></path></g></g></svg>
                </div>
              }
            </div>

            { getPortalLocData().name === 'airport' &&
              <GenericContent 
                history={this.props.history} 
                location={this.props.location}/>
            }
            

            { getPortalLocData().name != 'airport' &&
              <div className="row">
                <div className="col-md-7">
                  <LocationDetails/>
                </div>
                <div className="col-md-5">
                  <SpecialDealDetails/>
                </div>
              </div>
            }

        </div>
        
          
        </div>

      </div>

      
    );
  }
}

HomePage.propTypes = {

  homeActions: PropTypes.object.isRequired,
  locationDetail:PropTypes.object,
  history: PropTypes.object,
  userActions:PropTypes.object
};

function mapStateToProps(state) {
  return {
    locationDetail: state.locationDetail,
    pricing:state.pricing
  };
}

function mapDispatchToProps(dispatch) {
  return {
    homeActions: bindActionCreators(homeActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
    pricingActions: bindActionCreators(pricingActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);


// WEBPACK FOOTER //
// ./src/containers/HomePage.jsx